/* import __COLOCATED_TEMPLATE__ from './sidebar.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();